import React from 'react';

import './thankYouPage.css';
import 'font-awesome/css/font-awesome.min.css';
import LabelValuePair from './LabelValuePair';
import Legal from './Legal';
import {isSettingEnabled} from './setting-enabled';

// must be a class for ReactToPrint to work
// eslint-disable-next-line react/prefer-stateless-function
class PrintableThankYouRegion extends React.Component {
    render() {
        const {details, reservation: registration} = this.props;

        const buildKeyValueDisplay = (fieldName) => {
            const fieldSettings = details.form.fields[fieldName];

            if (fieldSettings && isSettingEnabled(fieldSettings.show)) {
                return (
                    <LabelValuePair
                        key={fieldName}
                        label={fieldSettings.label}
                        value={registration[fieldName]}
                    />
                );
            }

            return null;
        };

        return (
            <div>
                <h6 className="hy-vee-red">{details.title}{': registration complete!'}</h6>
                <h5>{details.thankYou.bold}</h5>
                {[
                    'firstName',
                    'lastName',
                    'textField1',
                    'address',
                    'city',
                    'state',
                    'zip',
                    'email',
                    'phone',
                    'textField2'
                ].map(buildKeyValueDisplay)}
                <p>{details.thankYou.message}</p>

                <p className="ThankYouPage-dateTime">
                    {'Date/Time:'}
                    <span className="heavy">
                        {details.date}
                    </span>
                </p>

                <p className="ThankYouPage-location">
                    {'Location:'}
                    <span className="heavy">
                        {details.venue.name}
                        {', '}
                    </span>
                    <span className="heavy">
                        {details.venue.address}
                    </span>
                </p>
                <Legal legal={details.form.legal} />
            </div>
        );
    }
}

export default PrintableThankYouRegion;



// WEBPACK FOOTER //
// ./src/event/PrintableThankYouRegion.js